import {
    action,
    observable,
    makeObservable,
    runInAction,
} from "mobx";
import api from "../../../../api";
import {Modal, message} from "antd";
import CommonStore from "../../common_store";

// import { CheckboxValueType } from "antd/es/checkbox/Group";

class ANumberManageStore {
    //搜索表单字段
    @observable searchForm: powerSearchData = {};
    @observable searchFormModal: powerSearchData = {};
    @observable tableData: any = {};
    //表格加载状态
    @observable tableLoad: boolean = true;
    @observable previewTableLoad: boolean = true;
    //控制modal展开
    @observable open: boolean = false;
    //分页信息
    @observable pageData: IPageData = {
        page: 1,
        size: 10,
        changePage: (page: number, size: number) => {
            runInAction(() => {
                this.pageData.page = page;
                this.pageData.size = size;
                this.pageData = {...this.pageData};
            });
            this.manageAPoolNumberPage();
        },
    };
    // A池数据统计信息
    @observable getAllAPoolReadInfo: any = [];
    @observable getAllAPoolWriteInfo: any = [];
    //点击编辑框传值
    @observable lookPower: any = {};
    //预览弹窗loading
    @observable previewLoading: boolean = false;
    //编辑框控制字段
    @observable templateModal: IModal1 = {
        title: "",
        add: false,
        update: false,
        delete: false,
        updateModalType: (type: "add" | "update" | "delete") => {
        },
        get isOpen(): boolean {
            return this.add || this.update || this.delete;
        },
        open: (type: "add" | "update" | "delete", data: any) => {
            if (type === "add") {
                runInAction(() => {
                    this.templateModal.title = "新增预览";
                    this.templateModal.add = true;
                    this.templateModal.update = false;
                    this.templateModal.delete = false;
                });
            } else if (type === "update") {
                runInAction(() => {
                    this.templateModal.title = "修改预览";
                    this.templateModal.add = false;
                    this.templateModal.update = true;
                    this.templateModal.delete = false;
                });
            } else if (type === "delete") {
                runInAction(() => {
                    this.templateModal.title = "删除预览";
                    this.templateModal.add = false;
                    this.templateModal.update = false;
                    this.templateModal.delete = true;
                });
            }
        },
        close: () => {
            runInAction(() => {
                this.templateModal.add = false;
                this.templateModal.update = false;
                this.templateModal.delete = false;
                this.previewLoading = false
                this.pageDataModal.page = 1;
                this.pageDataModal.size = 10;
                this.searchFormModal = {};
            });
        },
    };
    //预览的分页信息
    @observable pageDataModal: IPageData = {
        page: 1,
        size: 10,
        changePage: (page: number, size: number) => {
            runInAction(() => {
                this.pageDataModal.page = page;
                this.pageDataModal.size = size;
                this.pageDataModal = {...this.pageDataModal};
            });
            this.previewPage(this.batchNumber);
        },
    };
    @observable tableDataModal: any = {};
    @observable batchNumber: string = "";
    // @observable checkedList: CheckboxValueType[] = [];
    @observable checkedList: string[] = [];
    @observable previewCountData: any = {};
    @observable allowSubmit: boolean = false;
    @observable statisticsData: any = {};
    @observable exportErrorFlag: any = false;
    @observable showMore: any = false;

    commonStore: CommonStore;

    constructor(baseStore: CommonStore) {
        this.commonStore = baseStore;
        makeObservable(this);
    }

    setSearchForm(obj: powerSearchData) {
        runInAction(() => {
            this.searchForm = obj;
        });
    }

    setSearchModalForm(obj: powerSearchData) {
        runInAction(() => {
            this.searchFormModal = obj;
        });
    }

    //重置分页
    resetPage() {
        runInAction(() => {
            this.pageData.page = 1;
            this.pageDataModal.page = 1;
        });
    }

    @action
    manageAPoolNumberPage() {
        runInAction(() => {
            this.tableData = {};
            this.tableLoad = true;
        });
        const data = {...this.searchForm};
        data.size = this.pageData.size;
        data.page = this.pageData.page;
        api.aNumberManageApi
            .manageAPoolNumberPage(data)
            .then((res: any) => {
                this.getAllAPool(0);
                this.statistics(this.searchForm.callInitializerNumberPoolNo);
                if (res.code == 200) {
                    runInAction(() => {
                        this.tableData = res.data;
                        this.tableData = {...this.tableData};
                        this.tableLoad = false;
                    });
                    this.commonStore.getPagePermission("apool_number_management");
                }
            })
            .catch((e: any) => {
                runInAction(() => {
                    this.tableLoad = false;
                });
            });
    }

    @action
    getAllAPool(data: number) {
        api.aNumberManageApi
            .getAllAPool(data)
            .then(async (res: any) => {
                if (data === 0) {
                    runInAction(() => {
                        this.getAllAPoolReadInfo = res.data;
                    });
                } else {
                    runInAction(() => {
                        this.getAllAPoolWriteInfo = res.data;
                    });
                }
            })
            .catch((e: any) => {
            });
    }

    @action
    editAPoolNumber(data: any) {
        api.aNumberManageApi
            .editAPoolNumber(data)
            .then((res: any) => {
                this.manageAPoolNumberPage();
                message.success("编辑成功");
            })
            .catch((e: any) => {
            });
    }

    @action
    deleteAPoolNumber(data: any) {
        api.aNumberManageApi
            .deleteAPoolNumber(data)
            .then((res: any) => {
                message.success("删除成功");
                this.resetPage();
                this.manageAPoolNumberPage();
            })
            .catch((e: any) => {
            });
    }

    deletePower(data: any) {
        return new Promise((resolve, reject) => {
            Modal.confirm({
                centered: true,
                title: "确认删除",
                content: "您确定要删除该号码吗？",
                okText: "确认",
                cancelText: "取消",
                onOk: () => {
                    this.deleteAPoolNumber(data);
                    return resolve(true);
                },
                onCancel: () => {
                    return false;
                },
            });
        });
    }

    @action
    addAPoolNumber(data: any) {
        api.aNumberManageApi
            .addAPoolNumber(data)
            .then(async (res: any) => {
                this.resetPage();
                this.manageAPoolNumberPage();
                message.success("新增成功");
            })
            .catch((e: any) => {
            });
    }

    @action
    addPreview(data: any, modal: any) {
        runInAction(() => {
            this.previewLoading = true
        });
        api.aNumberManageApi
            .addPreview(data)
            .then(async (res: any) => {
                runInAction(() => {
                    this.batchNumber = res.data.batchNumber;
                    this.exportErrorFlag = res.data.exportErrorFlag;
                });
                this.previewPage(this.batchNumber);
            }).catch((e: any) => {
            this.templateModal.close()
        })
    }

    @action
    editPreview(data: any, modal: any) {
        runInAction(() => {
            this.previewLoading = true
        });
        api.aNumberManageApi
            .editPreview(data)
            .then(async (res: any) => {
                runInAction(() => {
                    this.batchNumber = res.data.batchNumber;
                    this.exportErrorFlag = res.data.exportErrorFlag;
                });
                this.previewPage(this.batchNumber);
            })
            .catch((e: any) => {
                this.templateModal.close()
            });
    }

    @action
    deletePreview(data: any, modal: any) {
        runInAction(() => {this.previewLoading = true})
        api.aNumberManageApi
            .deletePreview(data)
            .then(async (res: any) => {
                runInAction(() => {
                    this.batchNumber = res.data.batchNumber;
                    this.exportErrorFlag = res.data.exportErrorFlag;
                });
                this.previewPage(this.batchNumber);
            })
            .catch((e: any) => {
                this.templateModal.close()
            });
    }

    setLookPower(obj: any) {
        runInAction(() => {
            this.lookPower = obj;
        });
    }

    //预览数据分页查询
    @action
    previewPage(batchNumber?: string) {
        runInAction(() => {
            this.tableDataModal = {};
            this.previewTableLoad = true;
        });
        const data = {...this.searchFormModal};
        data.size = this.pageDataModal.size;
        data.page = this.pageDataModal.page;
        data.batchNumber = batchNumber ? batchNumber : this.batchNumber;
        api.aNumberManageApi
            .previewPage(data)
            .then((res: any) => {
                if (res.code == 200) {
                    runInAction(() => {
                        this.tableDataModal = res.data;
                        this.tableDataModal = {...this.tableDataModal};
                        this.previewTableLoad = false;
                    });
                }
                this.previewCount();
            })
            .catch((e: any) => {
                runInAction(() => {
                    this.previewTableLoad = false;
                });
                this.templateModal.close()
            });
    }

    @action
    previewCount() {
        api.aNumberManageApi
            .previewCount(this.batchNumber)
            .then((res: any) => {
                runInAction(() => {
                    this.previewCountData = res.data;
                    this.previewLoading = false
                });
                this.changeCheckList([]);
            })
            .catch((e: any) => {
                this.templateModal.close()
            });
    }

    @action changeCheckList(list: string[]) {
        // @action changeCheckList(list: CheckboxValueType[]) {
        console.log('CheckboxValueType', list);
        this.checkedList = [...list];
        let newpreviewCountData = {...this.previewCountData};
        delete newpreviewCountData.total
        this.checkedList.forEach((item: any) => {
            if (
                item === "poolRepeat" ||
                item === "tableRepeat" ||
                item === "numberNotExist" ||
                item === "otherError"
            ) {
                delete newpreviewCountData[item];
            }
        });
        let sum = 0;
        let arr: any = Object.values(newpreviewCountData);
        for (var i = arr.length - 1; i >= 0; i--) {
            sum += arr[i];
        }

        if (this.previewCountData.total === (this.previewCountData.poolRepeat + this.previewCountData.tableRepeat + this.previewCountData.numberNotExist + this.previewCountData.otherError)) {
            runInAction(() => {
                this.allowSubmit = true;
            });
        } else {
            runInAction(() => {
                this.allowSubmit = !Boolean(sum === 0);
            });
        }
    }

    @action
    batchAddAPoolNumber() {
        api.aNumberManageApi
            .batchAddAPoolNumber(this.batchNumber)
            .then((res: any) => {
                message.success("新增成功");
            })
            .catch((e: any) => {
            });
    }

    @action
    batchEditAPoolNumber() {
        api.aNumberManageApi
            .batchEditAPoolNumber(this.batchNumber)
            .then((res: any) => {
                message.success("编辑成功");
            })
            .catch((e: any) => {
            });
    }

    @action
    batchDeleteAPoolNumber() {
        api.aNumberManageApi
            .batchDeleteAPoolNumber(this.batchNumber)
            .then((res: any) => {
                message.success("删除成功");
            })
            .catch((e: any) => {
            });
    }

    @action
    exportError() {
        api.aNumberManageApi
            .exportError({batchNumber: this.batchNumber})
            .then(async (res: any) => {
                message.success("错误数据导出成功");
            })
            .catch((err: any) => {
                const blob = new Blob([err], {
                    type: 'application/vnd.ms-excel'
                })
                if ('download' in document.createElement('a')) {
                    // 生成<a></a >DOM元素
                    const link = document.createElement('a')
                    link.download = '错误数据导出.xlsx'
                    link.style.display = 'none'
                    // a标签的href属性指定下载链接
                    link.href = URL.createObjectURL(blob)
                    document.body.appendChild(link)
                    // 必须点击否则不会下载
                    link.click()
                    URL.revokeObjectURL(link.href)// 释放URL 对象
                    document.body.removeChild(link)
                }
            });
    }

    @action
    statistics(data: any) {
        api.aNumberManageApi
            .statistics({callInitializerNumberPoolNo: data})
            .then(async (res: any) => {
                runInAction(() => {
                    this.statisticsData = res.data;
                });
            })
            .catch((e: any) => {
            });
    }


}

export default ANumberManageStore;
